(function ($) {
	'use strict';

	$(function () {
		const $body = $('body');
		const $overlay = $('.js-body-overlay');
		const $trigger = $('.js-search-trigger');
		const $searchBody = $('.js-search-body');
		const $input = $('[type="search"]', $searchBody);
		const $close = $('.js-search-close');
		const overflowClass = 'u-overflow-hidden';
		const activeClass = 'is-active';

		$trigger.on('click', function () {
			const $nextBody = $(this).next($searchBody);

			$body.toggleClass(overflowClass);
			$overlay.toggleClass(activeClass);
			$nextBody.toggleClass(activeClass);

			if ($nextBody.hasClass(activeClass)) {
				setTimeout(function () {
					$input.trigger('focus');
				}, 300);
			}
		});

		$close.on('click', function () {
			$body.removeClass(overflowClass);
			$overlay.removeClass(activeClass);
			$(this).closest($searchBody).removeClass(activeClass);
		});
	});
})(jQuery);
